import React, { memo } from 'react'
import PropTypes from 'prop-types'

// Models
import TicketComment from 'models/TicketComment'

// Use
import { useSelector } from 'react-redux'

// Components
import Text from 'ui/Text'
import Avatar from 'ui/Avatar'
import TicketCommentAttachments from './TicketCommentAttachments'

export const TicketCommentItem = memo(({ comment }) => {
  // State
  const user = useSelector((state) => state.auth.user)

  return (
    <div style={{ padding: '10px 0' }}>
      <div className="media">
        <Avatar
          color={comment.isAdmin ? 'dark' : 'primary'}
          image={comment.isAdmin ? null : user.avatar}
          size="small"
        />
        <div className="media-body" style={{ marginLeft: '10px' }}>
          <Text bold color="#000000" size={15}>
            {comment.userName}
          </Text>
          <Text color="#5C5C5C" size={14}>
            {comment.createdAt}
          </Text>
        </div>
      </div>

      <Text
        color="#000000"
        paddingTop={20}
        paddingBottom={20}
        preline
        wordBreak
      >
        {comment.content}
      </Text>

      <TicketCommentAttachments files={comment.files} commentId={comment.id} />
    </div>
  )
})

TicketCommentItem.displayName = 'TicketCommentItem'

TicketCommentItem.propTypes = {
  comment: PropTypes.instanceOf(TicketComment),
}

TicketCommentItem.defaultProps = {
  comment: new TicketComment(),
}

export default TicketCommentItem
